<template>
  <div>Bienvenido, espera un momento...</div>
</template>
<script>
import LocalStorageKeys from "../../data/localStorageKeys";
export default {
  mounted() {
    const dni = this.$route.params.dni;
    const tokenGuardado = localStorage.getItem(LocalStorageKeys.cliente.token);

    if (tokenGuardado) {
      const dniGuardado = localStorage.getItem(LocalStorageKeys.cliente.dni);

      if (dniGuardado == dni) {
        // TODO: chequear expiración de token
        return this.$router.push("/");
      }
    }

    return this.$router.push({
      name: "login.clienteAndComerciante",
      params: { dni }
    });
  }
};
</script>